var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgMagnifyingGlass(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12.2634 11.5459L15 14.2825L14.2825 14.9995L11.5459 12.2634C10.8375 12.8165 9.97234 13.1189 9.05947 13.1189C7.97508 13.1189 6.95565 12.6968 6.18943 11.9295C5.42269 11.1633 5 10.1439 5 9.05947C5 7.97508 5.42269 6.95565 6.18943 6.18943C6.95565 5.42219 7.97508 5 9.05947 5C10.1439 5 11.1633 5.42219 11.9295 6.18943C12.6962 6.95565 13.1189 7.97508 13.1189 9.05947C13.1189 9.97234 12.816 10.8375 12.2634 11.5459ZM6.90694 11.2125C7.48186 11.7874 8.24605 12.1041 9.05947 12.1041C9.87289 12.1041 10.6371 11.7874 11.212 11.2125C11.7874 10.6376 12.1041 9.87289 12.1041 9.05947C12.1041 8.24656 11.7874 7.48186 11.212 6.90694C10.6371 6.33151 9.87289 6.01487 9.05947 6.01487C8.24605 6.01487 7.48186 6.33151 6.90694 6.90694C6.33151 7.48186 6.01487 8.24656 6.01487 9.05947C6.01487 9.87289 6.33151 10.6376 6.90694 11.2125Z",
    fill: ""
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgMagnifyingGlass);
export default __webpack_public_path__ + "static/media/magnifying-glass.52f21fb4fd8e9bdfd9b7efdbb8d58299.svg";
export { ForwardRef as ReactComponent };